export const CELL_COUNT = 7